<script lang="ts">
    export let checked: boolean = false;
</script>

<div class="form-check form-switch mb-3">
    <input
        type="checkbox"
        class="form-check-input"
        role="switch"
        bind:checked
    />
    <label class="form-check-label"> <slot /></label>
</div>

<style>
    div {
        font-size: 16px;
    }
</style>
